import Layout from './Layout';
import './Layout.scss';

export default Layout;